import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Checkbox, DatePicker, Radio, Badge } from 'antd';
import { FormInstance } from 'antd/lib/form';
import {
  DeleteOutlined,
  LeftOutlined,
  RightOutlined,
} from '@ant-design/icons';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ButtonLink from 'components/theme_components/ButtonLink';
import Notification from 'components/theme_components/Notifications';
import { AuthContext } from 'components/Auth/Auth';
import { toDatePickerDate } from 'utils/utils2';
import { TpAuthorizationResponse } from 'services/thirdParty';
import Title from 'antd/es/skeleton/Title';
import { Typography } from 'antd';

export type AuthorizationActivityModalProps = {
  form: FormInstance;
  setVisible: (visible: boolean) => void;
  comcode: string
  dataInput: TpAuthorizationResponse;
  onDone: any;
  loading: boolean
  onCancel: any;

};

const TabActivatePermeability = ({ setVisible, comcode, dataInput, form, onDone, loading, onCancel }: AuthorizationActivityModalProps) => {
  const { isInspect } = useContext(AuthContext);

  const { Title } = Typography;
  useEffect(() => {
    if (dataInput && dataInput.authDetail) {
      form.setFieldsValue({
        authid: dataInput.authid,
        event: 'TabActivatePermeability',
        flagexcludpermeabilitypm: dataInput.flagexcludpermeabilitypm ?? false
      })
    }
  }, [dataInput]);


  const validateFields = () => {
    form.validateFields().then(() => {
      onDone();

    })
  }

  return (
    <div >
      <FormInput
        name="flagexcludpermeabilitypm"
        className="form-item no-border-radius ut-task-modal-title"
        labelAlign="left"
        rules={[{ required: true }]}
        labelCol={{ span: 16 }}
        wrapperCol={{ span: 8 }}
      >
        <Radio.Group className='ut-radio-group' style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}>
          <Radio value={true}> Oui </Radio>
          <Radio value={false}> Non </Radio>
        </Radio.Group>
      </FormInput>

      <Row justify={'end'} style={{ marginTop: 13 }}>
        <ButtonLink
          comcode="Annuler"
          className="ut-btn-bordred"
          onClick={() => !isInspect && onCancel()}
        />
        <ButtonLink
          type="primary"
          comcode="Valider"
          htmlType="submit"
          className="ut-reset-btn"
          onClick={() => {
            !isInspect && validateFields()
          }
          }
          loading={loading}
          iconPosition="end"
        />
      </Row>
    </div>
  );
};

export default TabActivatePermeability;
